/* eslint-disable no-console */
import { map } from '@libs/shared';
import { getSafeLogData } from './format';
import { JS_API_PREFIX } from '../constant';

class SdkLogger {
    /**
     * 是否为调试模式
     */
    private _isDebug = false;

    /**
     * 设置调试模式
     * @param isDebug 是否开启调试模式
     */
    setIsDebug(isDebug: boolean) {
        this._isDebug = isDebug;
    }

    get isDebug() {
        return this._isDebug;
    }

    /**
     * 私有日志方法，处理公共逻辑
     * @param level 日志级别
     * @param message 日志消息
     * @param args 额外参数
     */
    private log(level: 'info' | 'warn' | 'error', message: string, ...args: any[]) {
        if (this._isDebug) {
            const visited = new WeakSet<object>();
            console[level](
                `${JS_API_PREFIX} ${message}`,
                ...map(args, (arg) => getSafeLogData(arg, visited))
            );
        }
    }

    info(message: string, ...args: any[]) {
        this.log('info', message, ...args);
    }

    warn(message: string, ...args: any[]) {
        this.log('warn', message, ...args);
    }

    error(message: string, ...args: any[]) {
        this.log('error', message, ...args);
    }
}

export const sdkLogger = new SdkLogger();
